__turbopack_context__.v({
  "image": "CollectionIcon-module__IChYaa__image",
  "inscription": "CollectionIcon-module__IChYaa__inscription",
  "punks": "CollectionIcon-module__IChYaa__punks",
  "root": "CollectionIcon-module__IChYaa__root",
});
